import deepmerge from "@node/deepmerge"

let locales = {};
const modules = import.meta.glob("@o-din-parking/../../config/locales/**/*.yml", { eager: true });

for (const path in modules) {
  locales = deepmerge(locales, modules[path].default);
}

import store from "@o-din-parking/src/parking/store.js";
import menu from "@o-din-parking/src/parking/menu.json";

export default {
  routes: [
    { path: '/parking/issues/', component: () => import("./views/parking/issues/Index.vue") },
    { path: '/parking/issues/archive', component: () => import("./views/parking/issues/Archive.vue") },
    { path: '/parking/issues/new', component: () => import("./views/parking/issues/New.vue") },
    { path: '/parking/issues/:id', component: () => import("./views/parking/issues/Show.vue") },
    { path: '/parking/categories/', component: () => import("./views/parking/categories/Index.vue") },
    { path: '/parking/categories/new', component: () => import("./views/parking/categories/Form.vue") },
    { path: '/parking/categories/:id/edit', component: () => import("./views/parking/categories/Form.vue") },
    { path: '/parking/categories/:id', component: () => import("./views/parking/categories/Show.vue") },
    { path: '/parking/vehicles/', component: () => import("./views/parking/vehicles/Index.vue") },
    { path: '/parking/vehicles/new', component: () => import("./views/parking/vehicles/Form.vue") },
    { path: '/parking/vehicles/:id/edit', component: () => import("./views/parking/vehicles/Form.vue") },
    { path: '/parking/vehicles/:id', component: () => import("./views/parking/vehicles/Show.vue") },
    { path: '/parking/vehicle_types/', component: () => import("./views/parking/vehicle_types/Index.vue") },
    { path: '/parking/vehicle_types/new', component: () => import("./views/parking/vehicle_types/Form.vue") },
    { path: '/parking/vehicle_types/:id/edit', component: () => import("./views/parking/vehicle_types/Form.vue") },
    { path: '/parking/parking_slots/', component: () => import("./views/parking/parking_slots/Index.vue") },
    { path: '/parking/parking_slots/new', component: () => import("./views/parking/parking_slots/Form.vue") },
    { path: '/parking/parking_slots/:id/edit', component: () => import("./views/parking/parking_slots/Form.vue") },
    { path: '/parking/parking_slots/:id', component: () => import("./views/parking/parking_slots/Show.vue") },
    { path: '/parking/passes/', component: () => import("./views/parking/passes/Index.vue") },
    { path: '/parking/passes/new', component: () => import("./views/parking/passes/Form.vue") },
    { path: '/parking/passes/:id/edit', component: () => import("./views/parking/passes/Form.vue") },
    { path: '/parking/passes/:id', component: () => import("./views/parking/passes/Show.vue") },
    { path: '/parking/simple_sessions/', component: () => import("./views/parking/simple_sessions/Index.vue") }
  ],
  locales,
  store,
  menu: [menu]
}
